module.exports = __webpack_public_path__ + "static/img/91BM-072-Kitty.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-072-Kitty.jpg
// module id = iW2P
// module chunks = 0